import { combineReducers } from 'redux';
import auth from 'modules/auth/auth.reducer';
import dashboard from 'modules/dashboard/dashboard.reducer';
import prescriptions from 'modules/prescriptions/prescriptions.reducer';

const rootReducer = combineReducers({ dashboard, auth, prescriptions });

export default rootReducer;
